/* Eastcrust OS — store behaviour: variant picker, gallery, cart quantities. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function formatMoney(cents, fmt) {
    var n = (cents / 100);
    var withComma = function (x, d, t, dec) { var p = x.toFixed(d).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (p[1] ? dec + p[1] : ''); };
    return String(fmt || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return withComma(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withComma(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withComma(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withComma(n, 2, "'", '.');
        default: return withComma(n, 2, ',', '.');
      }
    });
  }

  /* ── product page ── */
  function initProduct(root) {
    var json = $('[data-product-json]', root); if (!json) return;
    var variants = JSON.parse(json.textContent || '[]');
    var fmtEl = $('[data-money-format]', root); var fmt = fmtEl ? JSON.parse(fmtEl.textContent) : null;
    var idInput = $('[data-variant-id]', root), price = $('[data-price]', root), add = $('[data-add-button]', root), stock = $('[data-stock]', root);
    var mainMedia = $('[data-main-media]', root);
    var locked = document.documentElement.classList.contains('ecos-locked') && document.body.hasAttribute('data-lock-disable');

    function selected() { return $$('fieldset[data-option-index]', root).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function showMedia(id) {
      var btn = $('.ec-thumbs button[data-media-id="' + id + '"]', root); if (!btn || !mainMedia) return;
      $$('.ec-thumbs button', root).forEach(function (b) { b.classList.toggle('on', b === btn); });
      var img = $('img', mainMedia);
      if (img) { img.removeAttribute('srcset'); img.src = btn.dataset.src; img.alt = btn.dataset.alt || ''; }
    }
    function update() {
      var opts = selected();
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); })[0];
      // mark values that don't exist / are sold out with the rest of the current selection
      $$('fieldset[data-option-index]', root).forEach(function (fs) {
        var idx = +fs.dataset.optionIndex;
        $$('input', fs).forEach(function (inp) {
          var test = opts.slice(); test[idx] = inp.value;
          var m = variants.filter(function (x) { return x.options.every(function (o, i) { return o === test[i]; }); })[0];
          var lbl = inp.nextElementSibling; if (lbl) { lbl.style.opacity = (!m || !m.available) ? '.45' : ''; lbl.style.textDecoration = !m ? 'line-through' : ''; }
        });
      });
      if (!v) {
        if (add) { add.disabled = true; add.textContent = 'unavailable'; }
        if (stock) { stock.textContent = '● unavailable'; stock.classList.add('out'); }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (price) price.innerHTML = formatMoney(v.price, fmt) + (v.compare_at_price > v.price ? ' <s>' + formatMoney(v.compare_at_price, fmt) + '</s>' : '');
      locked = document.documentElement.classList.contains('ecos-locked') && document.body.hasAttribute('data-lock-disable');
      if (add) {
        add.disabled = !v.available || locked;
        add.textContent = locked ? (add.dataset.lockLabel || 'store locked') : (v.available ? 'add to cart' : 'sold out');
      }
      if (stock) { stock.textContent = v.available ? '● in stock' : '● sold out'; stock.classList.toggle('out', !v.available); }
      if (v.featured_media) showMedia(v.featured_media.id);
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
    }
    $$('fieldset[data-option-index] input', root).forEach(function (i) { i.addEventListener('change', update); });
    $$('.ec-thumbs button', root).forEach(function (b) { b.addEventListener('click', function () { showMedia(b.dataset.mediaId); }); });
    if ($$('fieldset[data-option-index]', root).length) update();
  }

  /* ── cart: quantity changes update the cart after a short pause ── */
  function initCart() {
    var form = $('#CartForm'); if (!form) return;
    var t = null, upd = $('[data-cart-update]', form);
    $$('[data-cart-qty]', form).forEach(function (i) {
      i.addEventListener('change', function () { clearTimeout(t); t = setTimeout(function () { if (upd) upd.click(); else form.submit(); }, 700); });
    });
  }

  /* ── related products load after the page ── */
  function initRecs() {
    $$('[data-recs-url]').forEach(function (el) {
      if (el.children.length) return;
      fetch(el.dataset.recsUrl).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var inner = $('[data-recs-url]', d); if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
      }).catch(function () {});
    });
  }

  /* ── collection tabs: click / arrow keys switch panels; #handle in the URL opens that tab ── */
  function initTabs(root) {
    var tabs = $$('[role="tab"]', root); if (!tabs.length) return;
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab, panel = document.getElementById(t.getAttribute('aria-controls'));
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus({ preventScroll: true });
      // bring the tab into view inside the tab row only; never scroll the page
      var bar = tab.parentNode, l = tab.offsetLeft - bar.offsetLeft, r = l + tab.offsetWidth;
      if (l < bar.scrollLeft) bar.scrollLeft = l - 8;
      else if (r > bar.scrollLeft + bar.clientWidth) bar.scrollLeft = r - bar.clientWidth + 8;
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var j = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 }[e.key];
        if (j === undefined) return;
        e.preventDefault(); select(tabs[(j + tabs.length) % tabs.length], true);
      });
    });
    var start = tabs[0], hash = decodeURIComponent(location.hash.slice(1));
    if (hash) tabs.forEach(function (t) {
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel && $('.ct-path', panel) && $('.ct-path', panel).textContent.split('/').pop() === hash) start = t;
    });
    select(start);
    // a link like /#hooded-sweatshirts opens that tab and brings the section into view
    if (start !== tabs[0]) root.scrollIntoView({ block: 'start' });
  }

  /* ── cart drawer: add to cart and cart links open it in place; phone back button closes it ── */
  function initDrawer() {
    var drawer = $('[data-cart-drawer]'); if (!drawer) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var cartPath = root + 'cart';
    var lastFocus = null, pushed = false, closeTimer = null;

    function isOpen() { return drawer.classList.contains('open'); }
    function lockState() {
      if (!(document.documentElement.classList.contains('ecos-locked') && document.body.hasAttribute('data-lock-disable'))) return;
      $$('[data-lock-disable-target]', drawer).forEach(function (b) { b.disabled = true; b.classList.add('is-disabled'); if (b.dataset.lockLabel) b.textContent = b.dataset.lockLabel; });
    }
    function render(sections) {
      var html = sections && sections['cart-drawer']; if (!html) return;
      var d = document.createElement('div'); d.innerHTML = html;
      var fresh = $('[data-cart-drawer]', d); if (!fresh) return;
      var hadFocus = drawer.contains(document.activeElement);
      drawer.innerHTML = fresh.innerHTML;
      lockState();
      var n = parseInt(($('[data-drawer-count]', drawer) || {}).textContent, 10) || 0;
      setCount(n);
      if (hadFocus) $('.ecd-panel', drawer).focus();
    }
    function setCount(n) {
      $$('a[href]').forEach(function (a) {
        if (a.pathname !== cartPath) return;
        if (a.classList.contains('h2-pill')) {
          var b = $('.cart-badge', a);
          if (n > 0) { if (!b) { b = document.createElement('span'); b.className = 'cart-badge'; a.appendChild(b); } b.textContent = n; }
          else if (b) b.remove();
          if (a.classList.contains('cart-pill')) a.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
        } else if (a.classList.contains('chip')) { var cv = $('.cv', a); if (cv) cv.textContent = n; }
        else if (/^cart:/.test(a.textContent.trim())) a.textContent = 'cart: ' + n;
      });
    }
    function refresh() {
      return fetch(root + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(render).catch(function () {});
    }
    function open() {
      clearTimeout(closeTimer);
      if (isOpen()) return;
      lastFocus = document.activeElement;
      drawer.hidden = false;
      document.documentElement.classList.add('ecd-lock');
      void drawer.offsetWidth;   // apply the closed position first so the slide-in animates
      drawer.classList.add('open');
      try { history.pushState({ ecDrawer: 1 }, ''); pushed = true; } catch (e) {}
      setTimeout(function () { var p = $('.ecd-panel', drawer); if (p) p.focus(); }, 30);
    }
    function close(fromHistory) {
      if (!isOpen()) return;
      drawer.classList.remove('open');
      document.documentElement.classList.remove('ecd-lock');
      closeTimer = setTimeout(function () { drawer.hidden = true; }, 260);
      if (pushed && !fromHistory) { pushed = false; history.back(); }
      pushed = false;
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    function change(line, qty) {
      drawer.classList.add('busy');
      return fetch(root + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty, sections: 'cart-drawer', sections_url: location.pathname })
      }).then(function (r) { return r.json(); }).then(function (j) { render(j.sections); })
        .catch(function () { location.href = cartPath; })
        .then(function () { drawer.classList.remove('busy'); });
    }

    window.addEventListener('popstate', function () { if (isOpen()) close(true); });
    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = $$('a[href], button:not([disabled]), input, textarea, [tabindex="0"]', drawer).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); close(); return; }
      var q = e.target.closest('[data-drawer-qty]');
      if (q && !drawer.classList.contains('busy')) change(parseInt(q.closest('[data-line]').dataset.line, 10), Math.max(0, parseInt(q.dataset.drawerQty, 10) || 0));
    });

    // cart links (nav pill, header chip, status bar) open the drawer instead of leaving the page
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a || drawer.contains(a) || a.hasAttribute('data-no-drawer') || a.pathname !== cartPath || a.origin !== location.origin) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault(); open(); refresh();
    });

    // add to cart without leaving the product
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.action || form.action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      var btn = $('[data-add-button]', form) || $('[type="submit"]', form);
      var label = btn ? btn.textContent : '', err = $('[data-add-error]', form);
      if (btn) { btn.disabled = true; btn.textContent = 'adding…'; }
      if (err) err.hidden = true;
      var body = new FormData(form);
      body.append('sections', 'cart-drawer'); body.append('sections_url', location.pathname);
      fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add this item.');
          render(res.j.sections); open();
        })
        .catch(function (x) { if (err) { err.textContent = x.message; err.hidden = false; } else form.submit(); })
        .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
    });

    // back/forward cache can show a stale cart
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  }

  /* ── product page back: return to the previous store page when there is one ── */
  function initBack() {
    $$('[data-back]').forEach(function (a) {
      var ref; try { ref = new URL(document.referrer); } catch (e) { return; }
      if (ref.origin !== location.origin || ref.pathname === location.pathname || history.length < 2) return;
      a.addEventListener('click', function (e) { e.preventDefault(); history.back(); });
    });
  }

  /* search box: focus it on computers only, without scrolling (autofocus pulled phones down the page) */
  function initAutofocus() {
    var el = $('[data-autofocus]');
    if (el && window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches) el.focus({ preventScroll: true });
  }

  function init() { $$('[data-product-section]').forEach(initProduct); $$('[data-ec-tabs]').forEach(initTabs); initCart(); initRecs(); initDrawer(); initBack(); initAutofocus(); }
  /* theme editor: re-init a reloaded section, open the tab whose block is selected */
  document.addEventListener('shopify:section:load', function (e) { $$('[data-ec-tabs]', e.target).forEach(initTabs); });
  document.addEventListener('shopify:block:select', function (e) { if (e.target.getAttribute('role') === 'tab') e.target.click(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
